const ErrorMassage = ({ message }) => {
  return (
    <div style={{marginTop: '1px'}} className="flex justify-start">
      <p className="text-red-500 text-base">{message?.[0]}</p>
    </div>
  )
}

export default ErrorMassage